"use strict";
/**
 * if value has been saved as a string ( tci usecase )
 * then the appropriate option needs to be found and set as
 * value in the format of { display: ..., value: ... }
 *
 * Because thats the only format our dropdowns understand
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue_MULTI = exports.getValue_SINGLE = exports.isGroupedData = void 0;
var toArray_1 = require("../../../../utils/toArray");
var getAllOptionsFns_1 = require("./getAllOptionsFns");
// Note: - saveValueAsString can be misleading here, because the value could be a string, integer, boolean values
// maybe we can rename to saveValueOnly, or some better name
// export const getValue_SINGLE = ({valueProp, optionsFn, options, theme,saveValueAsString}) => {
//     return saveValueAsString
//     ? (optionsFn ? getAllOptionsFns(theme)[optionsFn.fn](...(toArray(optionsFn.args) || [])) : options).find(d => d.value === valueProp)
//     : valueProp
// }
// export const getValue_MULTI = ({valueProp, optionsFn, options, theme,saveValueAsString}) => {
//     return saveValueAsString
//     ? valueProp?.map(vProp => (optionsFn ? getAllOptionsFns(theme)[optionsFn.fn](...(toArray(optionsFn.args) || [])) : options).find(d => d.value === vProp))
//     : valueProp
// }
var isGroupedData = function (options) {
    // If the data is empty or not an array, return false
    if (!options || !Array.isArray(options) || options.length === 0) {
        return false;
    }
    // Check the first item in the array
    // If it has an 'options' property that is an array, it's grouped data
    return (options[0] &&
        typeof options[0] === "object" &&
        Array.isArray(options[0].options) &&
        options[0].options.length > 0);
};
exports.isGroupedData = isGroupedData;
var getValue_SINGLE = function (_a) {
    var _b;
    var valueProp = _a.valueProp, optionsFn = _a.optionsFn, options = _a.options, theme = _a.theme, saveValueAsString = _a.saveValueAsString;
    if (!saveValueAsString)
        return valueProp;
    var allOptions = optionsFn ? (_b = (0, getAllOptionsFns_1.getAllOptionsFns)(theme))[optionsFn.fn].apply(_b, ((0, toArray_1.toArray)(optionsFn.args) || [])) : options;
    if ((0, exports.isGroupedData)(allOptions)) {
        // For grouped data, search through all options in all groups
        for (var _i = 0, allOptions_1 = allOptions; _i < allOptions_1.length; _i++) {
            var group = allOptions_1[_i];
            var found = group.options.find(function (d) { return d.value === valueProp; });
            if (found)
                return found;
        }
        return undefined;
    }
    else {
        // For normal data, search directly
        return allOptions.find(function (d) { return d.value === valueProp; });
    }
};
exports.getValue_SINGLE = getValue_SINGLE;
var getValue_MULTI = function (_a) {
    var _b;
    var valueProp = _a.valueProp, optionsFn = _a.optionsFn, options = _a.options, theme = _a.theme, saveValueAsString = _a.saveValueAsString;
    if (!saveValueAsString || !valueProp)
        return valueProp;
    var allOptions = optionsFn
        ? (_b = (0, getAllOptionsFns_1.getAllOptionsFns)(theme))[optionsFn.fn].apply(_b, ((0, toArray_1.toArray)(optionsFn.args) || [])) : options;
    if ((0, exports.isGroupedData)(allOptions)) {
        // For grouped data, map each value and search through all options in all groups
        return valueProp.map(function (vProp) {
            for (var _i = 0, allOptions_2 = allOptions; _i < allOptions_2.length; _i++) {
                var group = allOptions_2[_i];
                var found = group.options.find(function (d) { return d.value === vProp; });
                if (found)
                    return found;
            }
            return undefined;
        }).filter(Boolean); // Remove any undefined values
    }
    else {
        // For normal data, map directly
        return valueProp.map(function (vProp) {
            return allOptions.find(function (d) { return d.value === vProp; });
        }).filter(Boolean); // Remove any undefined values
    }
};
exports.getValue_MULTI = getValue_MULTI;
